import React, {useEffect} from 'react';
import { NativeBaseProvider } from "native-base";

import {NavigationContainer} from "@react-navigation/native";
import {LogBox, Platform, View, ActivityIndicator} from "react-native"; 

import AsyncStorage from '@react-native-async-storage/async-storage';
import {StatusBar} from "expo-status-bar";

import {i18n} from "./src/common/localization";

import {MainTabNavigator} from "./src/main-view/MainTabNavigator";
import {LoginNavigator} from "./src/login/LoginNavigator";
import {clearStoredAuth, subscribeToUnauthorized} from "./src/common/auth";

import { InstallLandingPage } from './src/InstallLandingPage'; 

// Ignore warnings from native-base
LogBox.ignoreLogs(["EventEmitter.removeListener"]);

//const getBrowserLanguage = () => {
//  if (typeof window !== 'undefined' && window.navigator) {
//    return window.navigator.language;
//  }
//  return 'it';
//};
//const rawLocale = getBrowserLanguage(); 
//const languageCode = rawLocale ? rawLocale.substring(0, 2).toLowerCase() : 'en';
//const supportedLanguages = ['it', 'en'];
//i18n.locale = supportedLanguages.includes(languageCode) ? languageCode : 'it';
//i18n.enableFallback = true; 

const isRunningInStandalone = () => {
  if (Platform.OS !== 'web') return true;
  if (typeof window === 'undefined') return false;
  return (window.navigator.standalone === true) || (window.matchMedia('(display-mode: standalone)').matches);
};

i18n.locale = "it";

export default function App() {
  const [login, setLogin] = React.useState("");
  const [userData, setUserData] = React.useState({});
  const [appIsReady, setAppIsReady] = React.useState(false);
  const isPaymentReturn = Platform.OS === "web"
      && typeof window !== "undefined"
      && new URLSearchParams(window.location.search).has("orderId");

  const [isPWA, setIsPWA] = React.useState(false);
  const [forceBrowserView, setForceBrowserView] = React.useState(false);

  useEffect(() => {
    setIsPWA(isRunningInStandalone());
  }, []);

  useEffect(() => {
      Promise.all([AsyncStorage.getItem('userName'), AsyncStorage.getItem('userData')])
          .then(([name, userData]) => {
            if(name) setLogin(name);
            if(userData) setUserData(JSON.parse(userData));
          })
          .catch((error) => {
             setLogin("");
          })
          .finally(() => {
             setAppIsReady(true);
          });
  }, []);

  useEffect(() => {
      const unsubscribe = subscribeToUnauthorized(() => {
          setUserData({});
          setLogin("");
      });
      return unsubscribe;
  }, []);

  function saveAccountData(accountData, token) {
      const userName = accountData["firstName"] + " " + accountData["lastName"];
      const userData = JSON.stringify(accountData);
      Promise.all([
          AsyncStorage.setItem('userName', userName),
          AsyncStorage.setItem('userToken', token),
          AsyncStorage.setItem('userData', userData)
      ])
          .then(() => {
              setUserData(accountData);
              setLogin(userName);
          });
  }

    function onPressLogout() {
      clearStoredAuth().then(() => {
          setUserData({});
          setLogin("");
      });
    }

  if (!appIsReady) {
    return (
        <NativeBaseProvider>
            <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#3A86C8' }}>
                <ActivityIndicator size="large" color="white" />
            </View>
        </NativeBaseProvider>
    );
  }

  if (Platform.OS === 'web' && !isPWA && !forceBrowserView && !isPaymentReturn) {
    return (
      <NativeBaseProvider>
         <InstallLandingPage onContinue={() => setForceBrowserView(true)} />
      </NativeBaseProvider>
    );
  }

  return (
      <NativeBaseProvider>
        <View style={{flex: 1}}>
          <NavigationContainer>
            {
              !login ?
                  <LoginNavigator saveAccountData={saveAccountData} /> :
                  <MainTabNavigator onPressLogout={onPressLogout} userName={login} userData={userData} />
            }
          </NavigationContainer>
            <StatusBar style="dark" />
        </View>
      </NativeBaseProvider>
  );
}
